<template>
  <tab-content-layout title="ENTRADA">
    <div class="row v-clean">
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
        <v-select-default
          label="TIPO"
          :items="stock_item_types"
          v-model="stock_item_type_id"
          @change="hanldeChangeStockItemType"
        />
      </div>
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
        <v-select-default
          label="CATEGORIA"
          :items="categories"
          v-model="stock_item_category_id"
          @change="hanldeFilter"
        />
      </div>
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
        <v-text-field-default
          label="BUSCAR"
          v-model="search_stock_items"
          @input="hanldeFilter"
        />
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <div
          class="v-primary p-2"
          v-if="
            resident_id &&
            stock_item_type &&
            stock_item_type.value == 'MEDICINE'
          "
        >
          <h6 class="m-0">
            SÓ É POSSÍVEL DAR ENTRADA EM MEDICAMENTOS QUE O RESIDENTE
            SELECIONADO POSSUI NA PRESCRIÇÃO ATIVA OU JÁ POSSUI NO ESTOQUE!
          </h6>
          <small>
            CASO O MEDICAMENTO QUE VOCÊ DESEJA DAR ENTRADA NÃO LISTE ABAIXO,
            ADICIONE-O NA PRESCRIÇÃO PARA PODER APARECER ABAIXO!
          </small>
        </div>
        <b-overlay :show="loadingItems" opacity="0.99">
          <div v-if="!resident_id">
            <div v-show="stock_items.length === 0" class="col-12 v-clean p-5">
              <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
            </div>
            <v-data-table
              v-show="stock_items.length > 0"
              dense
              showSelect
              singleSelect
              :headers="stock_items_headers"
              :items="stock_items"
              v-model="stock_item"
              :footer-props="{
                'items-per-page-options': [10, 25, 50],
                'items-per-page-text': 'Mostrar',
              }"
              :options.sync="options"
              :server-items-length="total"
            >
              <template v-slot:[`item.name`]="{ item }">
                {{
                  item.stock_item_type == "PRODUCT"
                    ? item.product_name
                    : item.medicine_name
                }}
              </template>
            </v-data-table>
          </div>
          <div v-if="resident_id">
            <div
              v-show="stock_items_resident.length === 0"
              class="col-12 v-clean p-5"
            >
              <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
            </div>
            <v-data-table
              v-show="stock_items_resident.length > 0"
              dense
              showSelect
              singleSelect
              :headers="stock_items_headers"
              :items="stock_items_resident"
              v-model="stock_item"
              :footer-props="{
                'items-per-page-options': [10, 25, 50],
                'items-per-page-text': 'Mostrar',
              }"
            >
              <template v-slot:[`item.name`]="{ item }">
                {{
                  item.stock_item_type == "PRODUCT"
                    ? item.product_name
                    : item.medicine_name
                }}
              </template>
            </v-data-table>
          </div>
        </b-overlay>
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <h4 class="title-pages">DESTINO</h4>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0">
        <v-select-default
          alternativeLabel
          required
          outlined
          :items="[
            { id: null, name: 'TODOS' },
            { id: 'ATIVO', name: 'ATIVO' },
            { id: 'INATIVO', name: 'INATIVO' },
          ]"
          item-text="name"
          item-value="id"
          label="RESIDENTES ATIVO/INATIVO"
          @change="getResidents"
          v-model="status_resident"
        />
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 pt-0 pb-0">
        <v-select-default
          item-text="name"
          item-value="id"
          alternativeLabel
          required
          :items="residents"
          label="PROPRIETÁRIO"
          v-model="resident_id"
          @change="hanldeFilter"
        />
      </div>
      <div
        :class="[
          'col-md-6 col-sm-6 col-12 pt-0 pb-0',
          stock_item_type_value == 'MEDICINE' && 'col-xl-4 col-lg-4',
          stock_item_type_value == 'PRODUCT' && 'col-xl-3 col-lg-3',
          stock_item_type_value != 'PRODUCT' &&
            stock_item_type_value != 'MEDICINE' &&
            'col-xl-4 col-lg-4',
        ]"
      >
        <v-select-default
          alternativeLabel
          required
          item-text="name"
          item-value="id"
          :items="groups"
          label="GRUPO"
          v-model="stock_group_id"
        />
      </div>
      <div
        class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-12 pt-0 pb-0"
        v-if="stock_item_type_value == 'PRODUCT'"
      >
        <v-text-field-default
          alternativeLabel
          required
          type="number"
          label="QUANTIDADE"
          v-model.number="quantity"
        />
      </div>
      <div
        :class="[
          'col-md-6 col-sm-6 col-12 pt-0',
          stock_item_type_value == 'MEDICINE' && 'col-xl-4 col-lg-4',
          stock_item_type_value == 'PRODUCT' && 'col-xl-3 col-lg-3',
          stock_item_type_value != 'PRODUCT' &&
            stock_item_type_value != 'MEDICINE' &&
            'col-xl-4 col-lg-4',
        ]"
      >
        <div :class="[stock_item_type_value == 'PRODUCT' && 'input-group']">
          <v-text-field-default
            alternativeLabel
            required
            type="number"
            :label="`${
              stock_item_unit_of_measurement_abbreviation
                ? stock_item_unit_of_measurement_abbreviation
                : 'QUANTIDADE'
            }`"
            v-model.number="amount"
          />
          <div
            v-if="stock_item_type_value == 'PRODUCT'"
            class="input-group-pprend v-dark d-flex align-items-center justify-content-center pl-5 pr-5"
          >
            = {{ quantity * amount }}
            {{ stock_item_unit_of_measurement_abbreviation }}
          </div>
        </div>
      </div>
    </div>
    <div class="row v-clean mt-2">
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
        <v-text-field-default
          type="date"
          label="DATA DE ENTRADA"
          alternativeLabel
          required
          v-model="entry_date"
        />
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
        <v-text-field-default
          alternativeLabel
          required
          :type="due_date_type"
          :label="due_date_label"
          v-model="due_date"
        />
      </div>
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
        <v-text-field-default
          alternativeLabel
          required
          type="text"
          label="LOTE"
          v-model="lot"
        />
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0">
        <v-text-field-default
          type="text"
          label="DESCRIÇÃO"
          v-model="description"
        />
        <warning-required-fields class="pt-3" />
      </div>
      <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
        <h4 class="title-pages">ENTRADAS</h4>
      </div>
      <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
        <v-btn-add-down
          :disabled="btnCreateOrderDisabled"
          @click="createOrder"
          text="ADICIONAR ENTRADA"
        />
      </div>
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <v-data-table-default
          :headers="entry_orders_headers()"
          :items="computed_entry_orders"
        >
          <template #[`item.amount`]="{ item }">
            <div v-if="item.type.value == 'PRODUCT'">
              {{ item.quantity * item.amount }}
              {{ item.unit_of_measurement_abbreviation }}
              <hr class="m-0" />
              <small>QUANTIDADE:</small> {{ item.quantity }}
            </div>
            <div v-if="item.type.value == 'MEDICINE'">
              {{ item.amount }} {{ item.unit_of_measurement_abbreviation }}
            </div>
          </template>
          <template #[`item.lot`]="{ item }">
            {{ item.lot }}
          </template>
          <template #[`item.entry_date`]="{ item }">
            {{ moment(item.entry_date).format("DD/MM/YYYY") }}
          </template>
          <template #[`item.due_date`]="{ item }">
            <span v-if="item.due_date && item.type.value == 'PRODUCT'">{{
              moment(item.due_date).format("DD/MM/YYYY")
            }}</span>
            <span v-if="item.due_date && item.type.value == 'MEDICINE'">{{
              moment(item.due_date).format("MM/YYYY")
            }}</span>
            <span v-if="!item.due_date">NÃO INFORMADO</span>
          </template>
          <template #[`item.actions`]="{ item }">
            <confirmation-dialog
              small
              message-title="EXCLUIR?"
              message-body="Deseja realmente excluir o produto?"
              open-class="btn-delete"
              open-left-icon="fa-trash"
              open-text="EXCLUIR"
              @yes="removeOrder(item.index)"
            />
          </template>
        </v-data-table-default>
      </div>
    </div>
    <errors-messages :errors="errors" />
    <b-row align-h="end">
      <b-col cols="auto">
        <v-btn-save
          :disabled="loading || computed_entry_orders.length == 0"
          :loading="loading"
          text="EXECUTAR"
          @click="execute"
        />
      </b-col>
    </b-row>
  </tab-content-layout>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";
import TabContentLayout from "../../Components/TabContentLayout.vue";
import VDataTableDefault from "../../Components/VDataTableDefault.vue";
import VSelectDefault from "../../Components/VSelectDefault.vue";
import VTextFieldDefault from "../../Components/VTextFieldDefault.vue";
import VBtnSave from "../../Components/VBtnSave.vue";
import VBtnAddDown from "../../Components/VBtnAddDown.vue";

import api from "../../../services/api";

import APIGet from "../../../lib/api-get";

import toast from "../../../lib/ToastNotification";

import ConfirmationDialog from "../../Components/ConfirmationDialog.vue";

import moment from "moment";
import WarningRequiredFields from "../../Components/WarningRequiredFields.vue";

export default {
  name: "Entry",

  components: {
    TabContentLayout,
    VSelectDefault,
    VDataTableDefault,
    VTextFieldDefault,
    ErrorsMessages,
    VBtnSave,
    VBtnAddDown,
    ConfirmationDialog,
    WarningRequiredFields,
  },

  data() {
    return {
      status_resident: "ATIVO",

      stock_item_type: null,

      entryType: "MEDICINE",
      total: 0,
      options: {},

      errors: [],
      loading: false,
      loadingItems: false,

      raw_residents: [],

      stock_items_headers: [{ text: "NOME", value: "name" }],

      stock_items: [],
      stock_items_resident: [],
      stock_item_types: [],
      stock_item_categories: [],
      stock_groups: [],
      stock_item_units_of_measurement: [],
      raw_associations: [],

      stock_item: [],
      unit_of_measurement: "",
      search_stock_items: "",
      stock_item_type_id: "",
      stock_item_category_id: "",
      resident_id: "",
      stock_group_id: "",
      amount: "",
      quantity: 1,
      entry_date: moment().format("YYYY-MM-DD"),
      due_date: "",
      lot: "",
      description: "",
      stock_item_unit_of_measurement_abbreviation: "",
      stock_item_type_value: "",

      entry_orders_base_headers: [
        { text: "PROPRIETÁRIO", value: "owner_name" },
        { text: "GRUPO", value: "stock_group_name" },
        { text: "ITEM", value: "stock_item_name" },
        { text: "QUANTIDADE", value: "amount" },
        { text: "LOTE", value: "lot" },
        { text: "DT/ENTRADA", value: "entry_date" },
        { text: "DT/VENCIMENTO", value: "due_date" },
        { text: "AÇÕES", value: "actions" },
      ],
      entry_orders: [],
    };
  },

  created() {
    this.retrieve();
  },

  computed: {
    categories() {
      return [
        { id: "", name: "SELECIONE" },
        ...this.stock_item_categories.filter(
          (item) => item.stock_item_type_id === this.stock_item_type_id
        ),
      ];
    },

    groups() {
      const selected_item =
        this.stock_item.length > 0 ? this.stock_item[0] : null;

      if (!selected_item) return [];

      return this.stock_groups.filter((group) =>
        this.raw_associations.some(
          (ass) =>
            ass.stock_group_id === group.id &&
            ass.stock_item_category_id === selected_item.stock_item_category_id
        )
      );
    },

    residents() {
      return [{ id: "", name: "EMPRESA" }, ...this.raw_residents];
    },

    units_of_measurement() {
      const selected_item =
        this.stock_item.length > 0 ? this.stock_item[0] : null;

      if (!selected_item) return [];

      const unit_of_measurement = this.stock_item_units_of_measurement.find(
        (unit) => unit.id === selected_item.stock_item_unit_of_measurement_id
      );

      return this.stock_item_units_of_measurement.filter(
        (unit) =>
          unit.stock_item_type_of_measure_id ===
          unit_of_measurement.stock_item_type_of_measure_id
      );
    },

    btnCreateOrderDisabled() {
      let {
        stock_item,
        amount,
        unit_of_measurement,
        stock_group_id,
        entry_date,
        due_date,
        lot,
      } = this;

      if (stock_item.length === 0) return true;
      if (!amount || amount <= 0) return true;
      if (!unit_of_measurement) return true;
      if (!stock_group_id) return true;
      if (!entry_date) return true;

      if (stock_item[0].type.value == "MEDICINE") {
        if (!due_date) return true;
        if (!lot) return true;
      }

      return false;
    },

    due_date_type() {
      return this.stock_item[0]?.type?.value === "PRODUCT" ? "date" : "month";
    },

    due_date_label() {
      return this.due_date_type === "date"
        ? "DATA DE VENCIMENTO"
        : "MÊS DE VENCIMENTO";
    },

    computed_entry_orders() {
      return this.entry_orders.map((entry_order, index) => ({
        index,
        ...entry_order,
        owner_name: entry_order.resident_id
          ? this.residents.find(
              (resident) => resident.id === entry_order.resident_id
            ).name
          : "EMPRESA",
        stock_group_name: this.stock_groups.find(
          (stock_group) => stock_group.id === entry_order.stock_group_id
        ).name,
        unit_of_measurement_abbreviation:
          this.stock_item_units_of_measurement.find(
            (item) => item.id === entry_order.stock_item_unit_of_measurement_id
          ).abbreviation,
      }));
    },
  },

  watch: {
    options: {
      handler() {
        if (this.resident_id) {
          this.getItemsByResident();
        } else {
          this.getItems();
        }
      },
    },

    stock_item() {
      if (this.stock_item.length > 0) {
        let item = this.stock_item[0];

        this.unit_of_measurement = this.units_of_measurement.find(
          (unit) => unit.id === item.stock_item_unit_of_measurement_id
        );
        this.amount = item.size;
        this.stock_item_unit_of_measurement_abbreviation =
          item.stock_item_unit_of_measurement_abbreviation;
        this.stock_item_type_value = item.stock_item_type_value;
      } else {
        this.unit_of_measurement = null;
        this.amount = "";
        this.stock_item_type_value = "";
        this.stock_item_unit_of_measurement_abbreviation = "";
      }
    },

    groups() {
      if (!this.groups.some((group) => group.id === this.stock_group_id))
        this.stock_group_id = null;
    },

    due_date_type() {
      this.due_date = "";
    },
  },

  methods: {
    moment,

    async getItemsByResident() {
      try {
        this.loadingItems = true;

        const {
          resident_id,
          stock_item_type_id,
          stock_item_category_id,
          search_stock_items,
        } = this;

        let params = {
          resident_id,
          stock_item_type_id,
          stock_item_category_id,
          search: search_stock_items,
        };

        const response = await api.get("/rest-home/stock-resident", { params });

        const { error, errors, data } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          for (let stock_item of data) {
            let type = {
              name:
                stock_item.stock_item_type_value == "MEDICINE"
                  ? "MEDICAMENTO"
                  : "PRODUTO",
              value: stock_item.stock_item_type_value,
            };

            stock_item.type = type;
          }

          this.stock_items_resident = data;
        }

        this.loadingItems = false;
      } catch (error) {
        console.log(error);
      }
    },

    hanldeChangeStockItemType(id) {
      let { stock_item_types } = this;

      let stock_item_type = stock_item_types.find((type) => type.id == id);

      if (stock_item_type) {
        this.stock_item_type = stock_item_type;
        if (stock_item_type.value == "MEDICINE") {
          this.entryType = "MEDICINE";
        } else {
          this.entryType = "PRODUCT";
        }
      } else {
        this.stock_item_type = null;
      }

      this.hanldeFilter();
    },

    hanldeFilter() {
      this.stock_item = [];

      let { resident_id, stock_item_type } = this;

      if (
        resident_id &&
        stock_item_type &&
        stock_item_type.value == "MEDICINE"
      ) {
        this.getItemsByResident();
      } else {
        this.options.page = 1;
        this.getItems();
      }
    },

    async retrieve() {
      await this.getTypes();
      await this.getUnitsOfMeasurement();
      await this.getGroups();
      await this.getCategories();
      await this.getAssociations();
      await this.getResidents();

      if (this.resident_id) {
        await this.getItemsByResident();
      } else {
        await this.getItems();
      }
    },

    async getTypes() {
      this.loading = true;
      const { error, errors, stock_item_types } =
        await APIGet.getStockItemTypes();
      this.errors = errors;
      this.stock_item_types = error ? [] : stock_item_types;
      if (stock_item_types.length > 0) {
        this.stock_item_type_id = stock_item_types[0].id;
        this.stock_item_type = stock_item_types[0];
      }
      this.loading = false;
    },

    async getGroups() {
      this.loading = true;
      const { error, errors, stock_groups } = await APIGet.getStockGroups();
      this.errors = errors;
      this.stock_groups = error ? [] : stock_groups;
      this.loading = false;
    },

    async getCategories() {
      this.loading = true;
      const { error, errors, stock_item_categories } =
        await APIGet.getStockItemCategories();
      this.errors = errors;
      this.stock_item_categories = error ? [] : stock_item_categories;
      this.loading = false;
    },

    async getItems() {
      try {
        this.loading = true;

        const {
          stock_item_type_id,
          stock_item_category_id,
          search_stock_items,
        } = this;

        const { page, itemsPerPage, sortBy, sortDesc } = this.options;

        const params = {
          stock_item_type_id,
          stock_item_category_id,
          page,
          itemsPerPage,
          search: search_stock_items,
          sortBy,
          sortDesc,
        };

        const response = await api.get("/rest-home/stock/items", { params });

        const { error, errors, stock_items, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          for (let stock_item of stock_items) {
            let type = {
              name:
                stock_item.stock_item_type == "MEDICINE"
                  ? "MEDICAMENTO"
                  : "PRODUTO",
              value: stock_item.stock_item_type,
            };

            let category = {
              name: stock_item.stock_item_category_name,
              stock_item_type_name: stock_item.stock_item_type_name,
              stock_item_type_value: stock_item.stock_item_type_value,
            };

            stock_item.type = type;
            stock_item.category = category;
          }

          this.stock_items = stock_items;
          this.stock_items_resident = stock_items;
          this.total = total;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getUnitsOfMeasurement() {
      this.loading = true;
      const { error, errors, stock_item_units_of_measurement } =
        await APIGet.getStockItemUnitsOfMeasurement();
      this.errors = errors;
      this.stock_item_units_of_measurement = error
        ? []
        : stock_item_units_of_measurement;
      this.loading = false;
    },

    async getAssociations() {
      this.loading = true;
      const { error, errors, associations } =
        await APIGet.getStockGroupsAssociatedCategories();
      this.errors = errors;
      this.raw_associations = error ? [] : associations;
    },

    async getResidents() {
      this.loading = true;
      let { status_resident } = this;
      const { error, errors, residents } = await APIGet.getResidents({
        status_resident,
      });
      this.errors = errors;
      this.raw_residents = error ? [] : residents;
      this.loading = false;
    },

    createOrder() {
      let {
        resident_id,
        stock_group_id,
        unit_of_measurement,
        amount,
        quantity,
        entry_date,
        due_date,
        lot,
        description,
        stock_item,
      } = this;

      let item = stock_item[0];

      this.entry_orders.push({
        resident_id: resident_id || null,
        stock_group_id: stock_group_id,
        stock_item_id: item.id,
        stock_item_name: item.name,
        stock_item_unit_of_measurement_id: unit_of_measurement.id,
        amount,
        quantity,
        entry_date,
        due_date,
        lot,
        description,
        type: item.type,
        message: "",
      });

      this.amount = "";
      this.lot = "";
      this.due_date = "";
      this.description = "";
      this.stock_group_id = "";
      this.quantity = 1;
      this.stock_item = [];
    },

    removeOrder(index) {
      this.entry_orders.splice(index, 1);
    },

    entry_orders_headers() {
      const headers = [...this.entry_orders_base_headers];

      if (this.entry_orders.some((entry_order) => entry_order.message))
        headers.push({ text: "MENSAGEM", value: "message" });

      return headers;
    },

    async execute() {
      try {
        this.loading = true;

        const data = { entry_orders: this.entry_orders };
        const response = await api.post("/rest-home/stock/entry", data);
        const { error, errors, messages, message } = response.data;

        if (error) {
          this.errors = errors;

          if (messages) {
            this.entry_orders.map((item) => (item.message = ""));
            for (const msg of messages)
              this.entry_orders[msg.index].message = msg.message;
          }
        } else {
          this.errors = [];
          toast(message, "success");
          this.entry_orders = [];
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>